import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList, CommandSeparator,
} from './ui/command';
import { LayoutDashboard, FolderKanban, Database, Settings, FilePlus2, GitCompare, Wallet, HardHat } from 'lucide-react';

export function CommandPalette({ open, setOpen, projects = [] }) {
  const navigate = useNavigate();
  const go = (path) => { setOpen(false); navigate(path); };

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput data-testid="command-palette-input" placeholder="Search tenders, actions…" />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Navigate">
          <CommandItem onSelect={() => go('/')}><LayoutDashboard size={15} className="mr-2" />Dashboard</CommandItem>
          <CommandItem onSelect={() => go('/projects')}><FolderKanban size={15} className="mr-2" />Tenders</CommandItem>
          <CommandItem onSelect={() => go('/costing')}><Wallet size={15} className="mr-2" />Costing</CommandItem>
          <CommandItem onSelect={() => go('/budget')}><HardHat size={15} className="mr-2" />Projects</CommandItem>
          <CommandItem onSelect={() => go('/masters')}><Database size={15} className="mr-2" />Rate Masters</CommandItem>
          <CommandItem onSelect={() => go('/settings')}><Settings size={15} className="mr-2" />Settings</CommandItem>
        </CommandGroup>
        <CommandSeparator />
        <CommandGroup heading="Actions">
          <CommandItem onSelect={() => go('/projects?new=1')}><FilePlus2 size={15} className="mr-2" />New Tender</CommandItem>
        </CommandGroup>
        {projects.length > 0 && (
          <>
            <CommandSeparator />
            <CommandGroup heading="Tenders">
              {projects.map((p) => (
                <CommandItem key={p.id} value={`${p.code} ${p.name}`} data-testid={`command-palette-result-${p.id}`}
                  onSelect={() => go(`/projects/${p.id}`)}>
                  <FolderKanban size={15} className="mr-2 text-[hsl(var(--teal))]" />
                  <span className="font-num text-xs text-[hsl(var(--copper))]">{p.code}</span>
                  <span className="ml-2 truncate text-muted-foreground">{p.name}</span>
                </CommandItem>
              ))}
            </CommandGroup>
            <CommandGroup heading="Compare">
              {projects.map((p) => (
                <CommandItem key={`rev-${p.id}`} value={`compare ${p.code}`}
                  onSelect={() => go(`/projects/${p.id}/revisions`)}>
                  <GitCompare size={15} className="mr-2" />Revisions of {p.code}
                </CommandItem>
              ))}
            </CommandGroup>
          </>
        )}
      </CommandList>
    </CommandDialog>
  );
}
